import { jsx as _jsx } from "react/jsx-runtime";
import { RawHTML } from '@wordpress/element';
export default function FormSaveBlock({ attributes }) {
    const { portalId, formId } = attributes;
    if (portalId && formId) {
        return (_jsx(RawHTML, { className: "wp-block-leadin-hubspot-form-block", children: `[hubspot portal="${portalId}" id="${formId}" type="form"]` }));
    }
    return null;
}
